/** @flow */

import React from "react";
import classNames from "classnames";
import "./icons.style.scss";

type Props = $Exact<{
  color?: string,
  className?: string,
  onClick?: (event: SyntheticEvent<HTMLButtonElement>) => void,
}>;

const PhoneBook2Icon = (props: Props) => (
  <svg
    className={classNames("icons", props.color, props.className, {
      charcoal: !props.color,
    })}
    onClick={props.onClick}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
  >
    <g>
      <rect x="3.5" y="0.5" width="17" height="23" />
      <path d="M3.5,0.5 L1.5,0.5 C0.95,0.5 0.5,0.95 0.5,1.5 L0.5,22.5 C0.5,23.05 0.95,23.5 1.5,23.5 L3.5,23.5" />
      <path d="M13,12 L13,13.5 L15.538,14.226 C16.067,14.377 16.5,14.95 16.5,15.5 L16.5,18.5 L6.5,18.5 L6.5,15.5 C6.5,14.95 6.933,14.377 7.461,14.226 L10,13.5 L10,12" />
      <ellipse cx="11.5" cy="9.271" rx="3" ry="3.272" />
      <path d="M14.469,8.676 C13.969,9.176 12.539,9.174 12,8.171 C11,9.171 9.375,9.171 8.566,8.6" />
      <path d="M20.5,2 L21.5,2 C22.6,2 23.5,2.9 23.5,4 L23.5,7 L20.5,7" />
      <polyline points="20.5 7 23.5 7 23.5 12 20.5 12" />
      <polyline points="20.5 12 23.5 12 23.5 17 20.5 17" />
      <path d="M20.5,17 L23.5,17 L23.5,20 C23.5,21.1 22.6,22 21.5,22 L20.5,22" />
    </g>
  </svg>
);

export default PhoneBook2Icon;
